import { isNoTaxScheme } from '../constants/defaults';

/**
 * Normalizes party_tax_scheme for API submit (UAE customers/suppliers).
 * - Scheme + VAT → keep both (trimmed VAT)
 * - Scheme without VAT → omit party_tax_scheme
 * - No scheme (with or without VAT) → omit; VAT-without-scheme blocked by Yup
 */
export function normalizePartyTaxSchemeForSubmit(partyTaxScheme) {
  if (!partyTaxScheme) {
    return undefined;
  }

  const vat = partyTaxScheme.company_id?.trim();
  const taxScheme = partyTaxScheme.tax_scheme;

  if (!vat) {
    return undefined;
  }

  if (isNoTaxScheme(taxScheme)) {
    return undefined;
  }

  return {
    tax_scheme: taxScheme,
    company_id: vat,
  };
}
